<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="67%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="categoryFormRules" ref="categoryFormRef" label-width="80px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" style="width: 30%;"></el-input>
      </el-form-item>
      <el-form-item label="封面图" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/admin/upload_img"
            name="img"
            :show-file-list="false"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="栏目" prop="groupId">
        <el-select v-model="formData.groupId" placeholder="请选择栏目" filterable>
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="讲员" prop="speakerId">
        <el-select v-model="formData.speakerId" placeholder="请输入讲员姓名" filterable>
          <el-option
            v-for="item in speakerList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="是否推荐" prop="isSpeakerHot">
        <el-radio v-model="formData.isSpeakerHot" :label="1">是</el-radio>
        <el-radio v-model="formData.isSpeakerHot" :label="0">否</el-radio>
      </el-form-item> -->
      <el-form-item label="简介" prop="intro">
        <!-- <el-input v-model="formData.intro" type="textarea" :rows="3"></el-input> -->
        <el-upload :show-upload-list="false"
          :on-success="handleQuillSuccess"
          :format="['jpg','jpeg','png','gif']"
          :max-size="2048" multiple
          action="/proxy/admin/upload_img"
          name="img"
          style="display: none;"
        >
          <el-button id="quill_upload" icon="ios-cloud-upload-outline" ></el-button>
        </el-upload>
        <quill-editor ref="quillEditorRef" v-model="formData.intro" :options="editorOption" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm" :disabled="confirmDisable">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['clean']
]

export default {
  name: 'category_add',
  props: [
    'visible', 'id', 'groupList', 'speakerList'
  ],
  components: {
    'quill-editor': quillEditor
  },
  data () {
    return {
      title: '添加专辑',
      confirmDisable: false,
      formData: {
        name: '',
        pic: '',
        groupId: '',
        speakerId: '',
        intro: ''
      },
      editorOption: {
        placeholder: '编辑配置内容',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image (value) {
                if (value) {
                  document.querySelector('#quill_upload').click()
                }
              }
            }
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        }
      },
      picUrl: '',
      categoryFormRules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        pic: [
          { required: true, message: '头像不能为空', trigger: 'blur' }
        ],
        groupId: [
          { required: true, message: '栏目不能为空', trigger: 'blur' }
        ],
        speakerId: [
          { required: true, message: '讲员不能为空', trigger: 'blur' }
        ],
        intro: [
          { required: true, message: '介绍不能为空', trigger: 'blur' },
          { min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.categoryFormRef.resetFields()
      this.picUrl = ''
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.categoryFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.confirmDisable = true
        this.picUrl = ''
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑专辑'
        this.getInfo(this.id)
      }
      this.confirmDisable = false
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/category/info/' + id)
      if (res.code === 0) {
        this.formData = {
          name: res.data.name,
          pic: res.data.pic,
          groupId: res.data.group_id,
          speakerId: res.data.speaker_id,
          intro: res.data.intro
        }
        this.picUrl = res.data.pic_url
      }
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    },
    handleQuillSuccess (res) {
      // 获取富文本组件实例
      const quill = this.$refs.quillEditorRef.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        const length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.data.url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        console.log('图片插入失败')
      }
    }
  }
}
</script>

<style scoped>
</style>
